import { dashboardInitialPanes } from "../../constants/index";

let initialState = {
  newTabIndex: 0,
  activeKey: dashboardInitialPanes[0].key,
  panes: dashboardInitialPanes,
};
const Tab1 = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVE_KEY_ON_CHANGE":
      return {
        ...state,
        activeKey: action.payload,
      };
    case "SET_DASHBOARD_RESET":
      return {
        ...state,
        activeKey: action.activeKey,
        panes: action.panes,
      };
    case "SET_PANE":
      return {
        ...state,
        activeKey: action.activeKey,
        panes: action.panes,
      };
    case "SET_PANES_ADD":
      return {
        ...state,
        activeKey: action.activeKey,
        panes: action.panes,
      };
    case "SET_PANES_REMOVE":
      return {
        ...state,
        activeKey: action.activeKey,
        panes: action.panes,
      };
    case "SET_IS_DASHBOARD":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_SELECTED_ACCOUNT":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_UPDATE_DASHBOARD_PILL":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_UPDATE_DASHBOARD_SORTING":
      return {
        ...state,
        panes: action.panes,
      };

    case "SET_TEMPLATE_NAME":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_TEMPLATE_IN_PANE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_WIDGETS":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_WIDGET_GRAPH_DATA":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_GLOBAL_DATE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_GLOBAL_BRANDS":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_QUICK_FILTER":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_GLOBAL_FILTER":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_SECTION_FILTER":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_WIDGET_FILTER":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_DASHBOARD_FILTERS":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_UPDATE_GRAPH_TYPE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_IS_PINNED":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_IS_DEEP_DIVE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_IS_DEEP_DIVE_DASHBOARD":
      // This action is used to set the deep dive dashboard state in the specific pane
      // Always create a new array and new pane object to avoid mutating state
      if (
        action?.paneIndex >= 0 &&
        Array.isArray(state?.panes) &&
        state?.panes?.length
      ) {
        const updatedPanesWithDeepDiveDashboard = state.panes.map(
          (pane, idx) => {
            if (idx === action.paneIndex) {
              return {
                ...pane,
                isDeepDiveDashboard: action?.isDeepDiveDashboard ? true : false,
                // deep_dive: {
                //   infoBar: null,
                //   mentions: null,
                //   wordcloud: [],
                //   category: [],
                //   top_users: [],
                //   influencers: [],
                //   source_of_post: [],
                //   locations: [],
                // },
              };
            }
            return pane;
          }
        );
        global.panes = updatedPanesWithDeepDiveDashboard;
        return {
          ...state,
          panes: updatedPanesWithDeepDiveDashboard,
        };
      }

      return state;
    case "SET_IS_TICKET_TRANDS_VIEW":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_DEEPDIVE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_DASHBOARD_TEMPLATE_FILTERS":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_CLEAR_TEMPLATE_DATA":
      return {
        ...state,
        activeKey: action.activeKey,
        panes: action.panes,
      };
    case "SET_DASHBOARD_WIDGET_PROFILE_FILTERS":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_DASHBOARD_PRIVATE_CONVERSATION":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_DASHBOARD_PUBLIC_ENGAGEMENT_CONVERSATION":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_TICKET_IS_MODIFIED_DATE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_GLOBAL_PROFILE_FILTERS_LIST":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_DASHBOARD_CALLED_API_LIST":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_SELECTED_DEEPDIVE_WIDGET":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_ACTIVE_SECTION_ID":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_SIMPLE_VIEW_DURATION":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_CAMPAIGN_DATE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_IS_ACCESS_TYPE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_PANE_OFFSET":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_QUICK_FILTER_TEMPLATE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_IS_WIDGET_MAKER_OPEN_OBJ":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_EDITED_WIDGET_GRAPH_CONFIG":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_IS_PROLIFIC_USER_DEEP_DIVE":
      return {
        ...state,
        panes: action.panes,
      };
    case "SET_ADSSET_LIST_IN_PANE":
      let updatedPanesWithAdssetList = state?.panes;
      if (action?.paneIndex >= 0 && updatedPanesWithAdssetList?.length) {
        updatedPanesWithAdssetList[action?.paneIndex].adsset_list =
          action?.adssetList?.length > 0 ? action?.adssetList : [];
      }
      return {
        ...state,
        panes: updatedPanesWithAdssetList,
      };
    case "SET_ADSSET_VALUE_IN_PANE":
      let updatedPanesWithAdssetValue = state?.panes;
      if (action?.paneIndex >= 0 && updatedPanesWithAdssetValue?.length) {
        updatedPanesWithAdssetValue[action?.paneIndex].adsset_value =
          action?.adssetValue ? action?.adssetValue : null;
      }
      return {
        ...state,
        panes: updatedPanesWithAdssetValue,
      };
    case "SET_ADS_LIST_IN_PANE":
      let updatedPanesWithAdsList = state?.panes;
      if (action?.paneIndex >= 0 && updatedPanesWithAdsList?.length) {
        updatedPanesWithAdsList[action?.paneIndex].ads_list =
          action?.adsList?.length > 0 ? action?.adsList : [];
      }
      return {
        ...state,
        panes: updatedPanesWithAdsList,
      };
    case "SET_ADS_VALUE_IN_PANE":
      let updatedPanesWithAdsValue = state?.panes;
      if (action?.paneIndex >= 0 && updatedPanesWithAdsValue?.length) {
        updatedPanesWithAdsValue[action?.paneIndex].ads_value = action?.adsValue
          ? action?.adsValue
          : null;
      }
      return {
        ...state,
        panes: updatedPanesWithAdsValue,
      };
    case "SET_IS_ACTIVE_AD_CAMPAIGN_STATUS_IN_PANE":
      let updatedPanesWithAdCampaignStatus = state?.panes;
      if (action?.paneIndex >= 0 && updatedPanesWithAdCampaignStatus?.length) {
        updatedPanesWithAdCampaignStatus[
          action?.paneIndex
        ].is_active_ad_campaign = action?.status ? action?.status : false;
      }
      return {
        ...state,
        panes: updatedPanesWithAdCampaignStatus,
      };
    case "SET_SAVE_WIDGET_CHANGES":
      return {
        ...state,
        panes: action.panes,
      };

    default:
      return state;
  }
};

export default Tab1;
